export function learningPathEndpoints(blockId) {
  return {
    block: `user_learning_path_blocks/${blockId}`,
    sections: `user_learning_path_blocks/${blockId}/sections`,
    sectionDone: sectionId => [`user_learning_path_blocks/${blockId}/sections/`, sectionId],
    scormQuestions: `user_learning_path_blocks/${blockId}/scorm_questions`
  };
}
